@if(items?.length){

<ul class="m-t m-t-8-s m-t-8-m">
    @for(item of items; track item.id){
    <li [ngClass]="item.id === 'returns' ? 'm-t' : $first ? '' : 'm-t-1 m-t-2-s m-t-2-m'">
        @if(item.onClick){
        <button type="button"
                (click)="item.onClick()"
                class="b-a b-col-5 w-12 overflow-hidden"
                style="border-radius: 12px;">
            <ng-container *ngTemplateOutlet="itemTemplate; context: { $implicit: item }"></ng-container>
        </button>
        } @else if(item.link){
        <href class="b-a b-col-5 w-12 overflow-hidden"
              style="border-radius: 12px;"
              [hrefClass]="'w-12'"
              [link]="item.link">
            <ng-container *ngTemplateOutlet="itemTemplate; context: { $implicit: item }"></ng-container>
        </href>
        } @else {
        <span class="b-a b-col-5 w-12 overflow-hidden"
              style="border-radius: 12px;">
            <ng-container *ngTemplateOutlet="itemTemplate; context: { $implicit: item }"></ng-container>
        </span>
        }

    </li>
    }
</ul>
}

<ng-template #itemTemplate
             let-item>
    <span class="flex flex-justify-between flex-middle p-l p-r p-l-2-s p-l-2-m p-r-2-s p-r-2-m bg-col-52-s bg-col-52-m">
        <span class="flex flex-middle">
            @if(item.icon){
            <i class="flex"
               [ngClass]="item.icon"
               style="font-size: 36px;"></i>
            } @else if(item.image){
            <span class="b-a b-col-1"
                  style="border-radius: 50%; overflow: hidden;">
                <!-- alt="" is deliberate: item.title renders immediately after
                     this icon, so describing it would duplicate the label -->
                <img [ratio]="1"
                     [width]="36"
                     [height]="36"
                     [dfImage]="item.image"
                     alt="" />
            </span>
            }
            <span class="m-l-1 left">
                <span class="block p1 col-1 m-b-1">{{item.title | translate}}</span>
                <span class="block c1 col-11">{{item.subtitle | translate}}</span>
            </span>
        </span>
        @if(item.rightIcon){
        @if(isSM){
        <i class="flex"
           [ngClass]="item.rightIcon"
           style="font-size: 36px;"></i>
        } @else {

        <i class="flex"
           [ngClass]="item.rightIcon"
           style="font-size: 28px;"></i>
        }
        }
    </span>
</ng-template>